import type { HttpPort } from "~/lib/http";

export type HelpStatus = "open" | "resolved";

interface RawHelpRequest {
  id: string;
  category: string;
  message: string | null;
  status: HelpStatus;
  created_at: string;
  first_name: string;
  last_name: string;
}

export interface HelpRequestView {
  id: string;
  categoryIcon: string;
  categoryLabel: string;
  message: string | null;
  status: HelpStatus;
  studentName: string;
  dateLabel: string;
}

const categories: Record<string, { icon: string; label: string }> = {
  feeling_bad: { icon: "😔", label: "Fühlt sich nicht gut" },
  bullying: { icon: "😰", label: "Wird gemobbt" },
  talk: { icon: "💬", label: "Braucht ein Gespräch" },
  other: { icon: "❓", label: "Sonstiges" }
};

function present(value: RawHelpRequest): HelpRequestView {
  const category = categories[value.category] ?? { icon: "❓", label: value.category };
  const date = new Date(value.created_at);
  return {
    id: value.id,
    categoryIcon: category.icon,
    categoryLabel: category.label,
    message: value.message,
    status: value.status,
    studentName: `${value.first_name} ${value.last_name}`,
    dateLabel: `${date.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "2-digit" })} · ${date.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })}`
  };
}

export function createHelpModule(http: HttpPort, token: string) {
  return {
    async load(classId: string, status: HelpStatus): Promise<HelpRequestView[]> {
      const data = await http.request<{ requests?: RawHelpRequest[] }>({ path: `/help/${classId}?status=${status}`, token });
      return (data.requests ?? []).map(present);
    },
    async resolve(requestId: string): Promise<void> {
      await http.request({ path: `/help/${requestId}/resolve`, method: "PUT", token, body: {} });
    }
  };
}

export type HelpModule = ReturnType<typeof createHelpModule>;
